import { action, createAsyncAction } from 'typesafe-actions'
import { Dispatch } from 'redux'
import api from 'api/graphql/graphql'
import { Paging } from 'types/global'
import { generateDateAtMidnight } from 'utils'

export const COMMON_MATCHES_RESET = 'h2h/COMMON_MATCHES_RESET'
export const COMMON_MATCHES_COMPLETED = 'h2h/COMMON_MATCHES_COMPLETED'
export const COMMON_MATCHES_FAILED = 'h2h/COMMON_MATCHES_FAILED'
export const COMMON_MATCHES_REQUESTED = 'h2h/COMMON_MATCHES_REQUESTED'

export const requestCommonMatches = createAsyncAction(
  COMMON_MATCHES_REQUESTED,
  COMMON_MATCHES_COMPLETED,
  COMMON_MATCHES_FAILED
)<void, { matches: any[]; count: number }, Error>()

export const VS_INFO_REQUESTED = 'h2h/VS_INFO_REQUESTED'
export const VS_INFO_COMPLETED = 'h2h/VS_INFO_COMPLETED'
export const VS_INFO_FAILED = 'h2h/VS_INFO_FAILED'

export const requestVsInfo = createAsyncAction(
  VS_INFO_REQUESTED,
  VS_INFO_COMPLETED,
  VS_INFO_FAILED
)<void, any, Error>()

export const COMMON_COMPETITORS_REQUESTED = 'h2h/COMMON_COMPETITORS_REQUESTED'
export const COMMON_COMPETITORS_COMPLETED = 'h2h/COMMON_COMPETITORS_COMPLETED'
export const COMMON_COMPETITORS_FAILED = 'h2h/COMMON_COMPETITORS_FAILED'
export const COMMON_COMPETITORS_TIME_FILTER_UPDATED = 'h2h/COMMON_COMPETITORS_TIME_FILTER_UPDATED'

export const requestCommonCompetitors = createAsyncAction(
  COMMON_COMPETITORS_REQUESTED,
  COMMON_COMPETITORS_COMPLETED,
  COMMON_COMPETITORS_FAILED
)<void, any[], Error>()

export const getCommonMatches = (playerIds: string[], paging: Paging) => {
  return async (dispatch: Dispatch) => {
    try {
      if (playersInvalid(playerIds)) throw Error('invalid h2h players')
      dispatch(requestCommonMatches.request())
      dispatch(requestCommonMatches.success(await api.getCommonMatches(playerIds, paging)))
    } catch (e) {
      console.log('Could not fetch common matches', e)
      dispatch(requestCommonMatches.failure(e as Error))
    }
  }
}

export const getVsInfo = (playerIds: [string, string]) => {
  return async (dispatch: Dispatch) => {
    try {
      if (playersInvalid(playerIds)) throw Error('invalid h2h players')
      dispatch(requestVsInfo.request())
      dispatch(requestVsInfo.success(await api.getVsInfo(playerIds)))
    } catch (e) {
      console.log('Could not fetch vs info', e)
      dispatch(requestVsInfo.failure(e as Error))
    }
  }
}

export const getCommonCompetitors = (playerIds: string[], timePeriod: number | null) => {
  return async dispatch => {
    let from
    if (timePeriod) {
      const start = timePeriod
      const today = new Date().getTime()
      const range = Math.abs(today - start)
      from = generateDateAtMidnight({ dateInput: range }).toISOString()
    }

    try {
      if (playersInvalid(playerIds)) throw Error('invalid h2h players')
      dispatch(requestCommonCompetitors.request())
      dispatch(
        requestCommonCompetitors.success(await api.getCommonCompetitorMatches(playerIds, from))
      )
    } catch (e) {
      console.log('Could not fetch common competitor matches', e)
      dispatch(requestCommonCompetitors.failure(e as Error))
    }
  }
}

export const updateCommonCompetitorsTimeFilter = (timePeriod: number | null) =>
  action(COMMON_COMPETITORS_TIME_FILTER_UPDATED, timePeriod)

const playersInvalid = playerIds => {
  return (
    !playerIds || playerIds.length < 2 || playerIds.some(p => !p) || playerIds[0] === playerIds[1]
  )
}

export const clearCommonMatches = () => action(COMMON_MATCHES_RESET)

export const VS_PLAYER_IDS_UPDATED = 'h2h/VS_PLAYER_IDS_UPDATED'
export const updateVsPlayerIds = (playerIds: [string, string]) =>
  action(VS_PLAYER_IDS_UPDATED, playerIds)
